import { BASTING_TYPES_BY_NAME } from '@nandosaus/constants';
import { get, trim } from 'lodash';

const getBastingKey = basting => get(BASTING_TYPES_BY_NAME, trim(basting.label));

export { getBastingKey };
